import { useTranslation } from 'react-i18next';
import { errorCodes } from '@const/error_codes';
import handleRequestError from '@utils/errors';
import { showToast } from '@components/toast';

export const useLocales = () => {
    const { t } = useTranslation(['form', 'requests', 'submit']);

    const validationLocale = (string: string) => {
        return t(`validation.${string}`, { ns: 'form' });
    };

    const labelLocale = (string: string) => {
        return t(`labels.${string}`, { ns: 'form' });
    };

    const placeholderLocale = (string: string) => {
        return t(`placeholders.${string}`, { ns: 'form' });
    };

    const requestSuccessLocale = (string: string) => {
        return showToast.success(t(`success.${string}`, { ns: 'requests' }));
    };

    const requestErrorLocale = (e: any, conflictMessage?: string) => {
        if (!e?.errorCode || !errorCodes.includes(e?.errorCode)) {
            return showToast.error(
                t(`error.${handleRequestError(e?.statusCode, conflictMessage)}`, { ns: 'requests' })
            );
        }
        return showToast.error(t(`error.${e?.errorCode}`, { ns: 'requests' }));
    };

    const submitLocale = (string: string) => {
        return t(string, { ns: 'submit' });
    };

    return {
        validationLocale,
        labelLocale,
        placeholderLocale,
        requestSuccessLocale,
        requestErrorLocale,
        submitLocale,
        t
    };
};
